class Auth {
    authenticated: boolean;
    constructor() {
      this.authenticated = false;
      const token = localStorage.getItem("token");
      if (token !== null) {
        this.authenticated = true;
      }
    }
  
    login(cb: () => void) {
      this.authenticated = true;
      cb();
    }
  
    logout(cb: () => void) {
      this.authenticated = false;
      localStorage.removeItem("token");
      cb();
    }
  
    isAuthenticated() {
      return this.authenticated;
    }
  }
  
  export default new Auth();
  